import React from 'react';

import { balance } from './changeRequestFormat';

/**
 * The balance-impact block, shared by the read-only Budget Changes pop-up and
 * Home's actionable one so the two screens cannot show different money — or
 * different WARNINGS — for the same request. Renders nothing when the funding
 * carries no impact figures at all.
 *
 * `negativeWarning`: whether the pending action would take a shown balance
 * below zero. Only the actionable pop-up ever has an action to warn about, so
 * the read-only screen never sets this — nothing here blocks the approval,
 * it only colours the figures that are about to be approved by accident.
 */
export default function BalanceImpactCallout({ funding, negativeWarning = false }) {
    const hasImpact = funding.balance_before !== null && funding.balance_before !== undefined;
    const hasCentralImpact = funding.central_balance_before !== null && funding.central_balance_before !== undefined;

    if (!hasImpact && !hasCentralImpact) {
        return null;
    }

    return (
        <div className={`bc-impact${negativeWarning ? ' tw-text-red bc-impact--negative' : ''}`}>
            {hasImpact &&
                (funding.at_approval ? (
                    <>
                        <b>{$t('Balance at approval')}</b>:{' '}
                        {$t('{{contingency}} {{before}} → {{after}}', {
                            contingency: funding.contingency_label,
                            before: balance(funding.balance_before),
                            after: balance(funding.balance_after),
                        })}
                    </>
                ) : (
                    <>
                        <b>{$t('Balance impact on approval')}</b>:{' '}
                        {$t('{{contingency}} {{before}} → {{after}} for this item.', {
                            contingency: funding.contingency_label,
                            before: balance(funding.balance_before),
                            after: balance(funding.balance_after),
                        })}
                        {funding.cumulative_count > 0 && (
                            <>
                                {' '}
                                {$t('Cumulative in approval order ({{index}} of {{count}} pending): {{remaining}} remaining after all pending requests.', {
                                    index: funding.cumulative_index,
                                    count: funding.cumulative_count,
                                    remaining: balance(funding.cumulative_remaining),
                                })}
                            </>
                        )}
                    </>
                ))}

            {/* A split-funded change moves BOTH pots, and the figures above
                report only the one the row is attributed to. */}
            {hasCentralImpact && (
                <>
                    {hasImpact && ' '}
                    {$t('Central contingency {{before}} → {{after}}.', {
                        before: balance(funding.central_balance_before),
                        after: balance(funding.central_balance_after),
                    })}
                </>
            )}

            {negativeWarning && (
                <>
                    {' '}
                    <b>{$t('Approving this takes the balance below zero.')}</b>
                </>
            )}
        </div>
    );
}
